"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Leitung = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const Article_1 = require("../Article");
class Leitung extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'Leitung';
    }
    get aussendurchmesser() {
        return echain_shared_quantities_1.Q.optional(this.model.Aussendurchmesser);
    }
    set aussendurchmesser(value) {
        this.model.Aussendurchmesser = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get beschriftung() {
        return this.model.Beschriftung;
    }
    set beschriftung(value) {
        this.model.Beschriftung = value;
    }
    get beschriftungText() {
        return this.model.BeschriftungText;
    }
    set beschriftungText(value) {
        this.model.BeschriftungText = value;
    }
    get beschriftungFixedEnd() {
        return this.model.BeschriftungFixedEnd;
    }
    set beschriftungFixedEnd(value) {
        this.model.BeschriftungFixedEnd = value;
    }
    get beschriftungFixedEndText() {
        return this.model.BeschriftungFixedEndText;
    }
    set beschriftungFixedEndText(value) {
        this.model.BeschriftungFixedEndText = value;
    }
    get bestTyp() {
        return this.model.BestTyp;
    }
    set bestTyp(value) {
        this.model.BestTyp = value;
    }
    get discontinuedModel() {
        return Boolean(this.model.DiscontinuedModel);
    }
    get isBeschriftungTextManuallyChanged() {
        return this.model.IsBeschriftungTextManuallyChanged;
    }
    set isBeschriftungTextManuallyChanged(value) {
        this.model.IsBeschriftungTextManuallyChanged = value;
    }
    get kupferzahl() {
        return echain_shared_quantities_1.Q.optional(this.model.Kupferzahl);
    }
    set kupferzahl(value) {
        this.model.Kupferzahl = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get localizedLeitungsaufbau() {
        return this.model.Leitungsaufbau;
    }
    set localizedLeitungsaufbau(value) {
        this.model.Leitungsaufbau = value;
    }
    get categories() {
        return this.model.Categories;
    }
    set categories(value) {
        this.model.Categories = value;
    }
    get mainCategory() {
        return this.model.MainCategory;
    }
    set mainCategory(value) {
        this.model.MainCategory = value;
    }
    get leitungslaenge() {
        return echain_shared_quantities_1.Q.optional(this.model.Leitungslaenge);
    }
    set leitungslaenge(value) {
        this.model.Leitungslaenge = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get ueberstandFestpunkt() {
        return echain_shared_quantities_1.Q.optional(this.model.UeberstandFestpunkt);
    }
    set ueberstandFestpunkt(value) {
        this.model.UeberstandFestpunkt = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get ueberstandMitnehmer() {
        return echain_shared_quantities_1.Q.optional(this.model.UeberstandMitnehmer);
    }
    set ueberstandMitnehmer(value) {
        this.model.UeberstandMitnehmer = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get laengeUeberstandLock() {
        return this.model.LaengeUeberstandLock;
    }
    set laengeUeberstandLock(value) {
        this.model.LaengeUeberstandLock = value;
    }
    get gewichtKgProKm() {
        return echain_shared_quantities_1.Q.optional(this.model.GewichtKgProKm);
    }
    set gewichtKgProKm(value) {
        this.model.GewichtKgProKm = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get biegeradiusMin() {
        return echain_shared_quantities_1.Q.optional(this.model.BiegeradiusMin);
    }
    set biegeradiusMin(value) {
        this.model.BiegeradiusMin = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get hatStecker() {
        return this.model.HatStecker;
    }
    set hatStecker(value) {
        this.model.HatStecker = value;
    }
    get festeLaenge() {
        return this.model.FesteLaenge;
    }
    set festeLaenge(value) {
        this.model.FesteLaenge = value;
    }
    get manufacturer() {
        return this.model.Manufacturer;
    }
    set manufacturer(value) {
        this.model.Manufacturer = value;
    }
    get manufacturerPartNo() {
        return this.model.ManufacturerPartNo;
    }
    set manufacturerPartNo(value) {
        this.model.ManufacturerPartNo = value;
    }
    get opti() {
        return this.model.Opti;
    }
    set opti(value) {
        this.model.Opti = value;
    }
    get ralNummer() {
        return this.model.RAL_Nummer;
    }
    set ralNummer(value) {
        this.model.RAL_Nummer = value;
    }
    get isPlaceholder() {
        return this.model.IsPlaceholder;
    }
    set isPlaceholder(value) {
        this.model.IsPlaceholder = value;
    }
    get cfx() {
        return this.model.CFX;
    }
    set cfx(value) {
        this.model.CFX = value;
    }
    get leitungIndex() {
        return this.model.LeitungIndex;
    }
    set leitungIndex(value) {
        this.model.LeitungIndex = value;
    }
    get localTransform() {
        return this.model.LocalTransform;
    }
    set localTransform(value) {
        this.model.LocalTransform = value;
    }
    get localTransformPosition() {
        return this.localTransform
            ? {
                x: this.localTransform[4],
                y: this.localTransform[5],
            }
            : undefined;
    }
    get _iaIndex() {
        return this.model.IAIndex;
    }
    set _iaIndex(value) {
        this.model.IAIndex = value;
    }
    get iaIndex() {
        return this._iaIndex;
    }
    get verfahrwegFreitragendMax() {
        return echain_shared_quantities_1.Q.optional(this.model.VerfahrwegFreitragendMax);
    }
    set verfahrwegFreitragendMax(value) {
        this.model.VerfahrwegFreitragendMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get verfahrwegGleitendMax() {
        return echain_shared_quantities_1.Q.optional(this.model.VerfahrwegGleitendMax);
    }
    set verfahrwegGleitendMax(value) {
        this.model.VerfahrwegGleitendMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get auhiFreitragendA() {
        return echain_shared_quantities_1.Q.optional(this.model.AuhiFreitragendA);
    }
    set auhiFreitragendA(value) {
        this.model.AuhiFreitragendA = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get auhiFreitragendV() {
        return echain_shared_quantities_1.Q.optional(this.model.AuhiFreitragendV);
    }
    set auhiFreitragendV(value) {
        this.model.AuhiFreitragendV = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get auhiGleitendA() {
        return echain_shared_quantities_1.Q.optional(this.model.AuhiGleitendA);
    }
    set auhiGleitendA(value) {
        this.model.AuhiGleitendA = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get auhiGleitendV() {
        return echain_shared_quantities_1.Q.optional(this.model.AuhiGleitendV);
    }
    set auhiGleitendV(value) {
        this.model.AuhiGleitendV = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get auhiGleitend() {
        return this.model.AuhiGleitend;
    }
    set auhiGleitend(value) {
        this.model.AuhiGleitend = value;
    }
    get auhiTemperaturMax() {
        return (0, echain_shared_quantities_1.Q)(this.model.AuhiTemperaturMax);
    }
    set auhiTemperaturMax(value) {
        this.model.AuhiTemperaturMax = value.quantity;
    }
    get auhiTemperaturMin() {
        return (0, echain_shared_quantities_1.Q)(this.model.AuhiTemperaturMin);
    }
    set auhiTemperaturMin(value) {
        this.model.AuhiTemperaturMin = value.quantity;
    }
    get haengenderBetriebErlaubt() {
        return this.model.HaengenderBetriebErlaubt;
    }
    set haengenderBetriebErlaubt(value) {
        this.model.HaengenderBetriebErlaubt = value;
    }
    get verfahrwegHaengendMax() {
        return echain_shared_quantities_1.Q.optional(this.model.VerfahrwegHaengendMax);
    }
    set verfahrwegHaengendMax(value) {
        this.model.VerfahrwegHaengendMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get beschleunigungHaengendMax() {
        return echain_shared_quantities_1.Q.optional(this.model.BeschleunigungHaengendMax);
    }
    set beschleunigungHaengendMax(value) {
        this.model.BeschleunigungHaengendMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get geschwindigkeitHaengendMax() {
        return echain_shared_quantities_1.Q.optional(this.model.GeschwindigkeitHaengendMax);
    }
    set geschwindigkeitHaengendMax(value) {
        this.model.GeschwindigkeitHaengendMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get stecker1() {
        return this.model.Stecker1;
    }
    set stecker1(value) {
        this.model.Stecker1 = value;
    }
    get stecker2() {
        return this.model.Stecker2;
    }
    set stecker2(value) {
        this.model.Stecker2 = value;
    }
    get steckerFp() {
        return this.model.SteckerFp;
    }
    set steckerFp(value) {
        this.model.SteckerFp = value;
    }
    get steckerMn() {
        return this.model.SteckerMn;
    }
    set steckerMn(value) {
        this.model.SteckerMn = value;
    }
    get localizedQuerschnitt() {
        return this.model.Querschnitt;
    }
    set localizedQuerschnitt(value) {
        this.model.Querschnitt = value;
    }
    get mantelwerkstoff() {
        return this.model.Mantelwerkstoff;
    }
    set mantelwerkstoff(value) {
        this.model.Mantelwerkstoff = value;
    }
    get aderzahl() {
        return this.model.Aderzahl;
    }
    set aderzahl(value) {
        this.model.Aderzahl = value;
    }
    get ulCsa() {
        return this.model.UL_CSA;
    }
    set ulCsa(value) {
        this.model.UL_CSA = value;
    }
    get dnvGl() {
        return this.model.DNV_GL;
    }
    set dnvGl(value) {
        this.model.DNV_GL = value;
    }
    get reinraum() {
        return this.model.Reinraum;
    }
    set reinraum(value) {
        this.model.Reinraum = value;
    }
    get halogenfrei() {
        return this.model.Halogenfrei;
    }
    set halogenfrei(value) {
        this.model.Halogenfrei = value;
    }
    get eac() {
        return this.model.EAC;
    }
    set eac(value) {
        this.model.EAC = value;
    }
    get desina() {
        return this.model.DESINA;
    }
    set desina(value) {
        this.model.DESINA = value;
    }
    get flammwidrig() {
        return this.model.Flammwidrig;
    }
    set flammwidrig(value) {
        this.model.Flammwidrig = value;
    }
    get kuehlmittelbestaendig() {
        return this.model.Kuehlmittelbestaendig;
    }
    set kuehlmittelbestaendig(value) {
        this.model.Kuehlmittelbestaendig = value;
    }
    get mudBestaendig() {
        return this.model.MUDBestaendig;
    }
    set mudBestaendig(value) {
        this.model.MUDBestaendig = value;
    }
    get oelbestaendigkeit() {
        return this.model.Oelbestaendigkeit;
    }
    set oelbestaendigkeit(value) {
        this.model.Oelbestaendigkeit = value;
    }
    get uvBestaendigkeit() {
        return this.model.UVBestaendigkeit;
    }
    set uvBestaendigkeit(value) {
        this.model.UVBestaendigkeit = value;
    }
    get minBiegeradiusFaktor() {
        return echain_shared_quantities_1.Q.optional(this.model.MinBiegeradiusFaktor);
    }
    set minBiegeradiusFaktor(value) {
        this.model.MinBiegeradiusFaktor = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get freitragenderBetriebErlaubt() {
        return this.model.FreitragenderBetriebErlaubt;
    }
    set freitragenderBetriebErlaubt(value) {
        this.model.FreitragenderBetriebErlaubt = value;
    }
    get torsionsfaehig() {
        return this.model.Torsionsfaehig;
    }
    set torsionsfaehig(value) {
        this.model.Torsionsfaehig = value;
    }
    get torsionswinkel() {
        return echain_shared_quantities_1.Q.optional(this.model.Torsionswinkel);
    }
    set torsionswinkel(value) {
        this.model.Torsionswinkel = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get localizedBusSystem() {
        return this.model.BusSystem;
    }
    set localizedBusSystem(value) {
        this.model.BusSystem = value;
    }
    get gesamtschirm() {
        return this.model.Gesamtschirm;
    }
    set gesamtschirm(value) {
        this.model.Gesamtschirm = value;
    }
    get schirmung() {
        return this.model.Schirmung;
    }
    set schirmung(value) {
        this.model.Schirmung = value;
    }
    get ungeschirmt() {
        return this.model.Ungeschirmt;
    }
    set ungeschirmt(value) {
        this.model.Ungeschirmt = value;
    }
    get baseArticleRef() {
        return this.model.BaseArticleRef;
    }
    get subCategory() {
        return this.model.SubCategory;
    }
    get twistedPair() {
        return this.model.TwistedPair;
    }
    set twistedPair(value) {
        this.model.TwistedPair = value;
    }
    get aderzahlBerechnet() {
        return this.model.AderzahlBerechnet;
    }
    set aderzahlBerechnet(value) {
        this.model.AderzahlBerechnet = value;
    }
    get localizedTextConnectorFp() {
        if (!this.steckerFp || !this.stecker1 || !this.stecker2)
            return undefined;
        if (this.steckerFp === 1)
            return this.stecker1;
        return this.stecker2;
    }
    get localizedTextConnectorMn() {
        if (!this.steckerMn || !this.stecker1 || !this.stecker2)
            return undefined;
        if (this.steckerMn === 1)
            return this.stecker1;
        return this.stecker2;
    }
    static fromScratch() {
        return new Leitung({
            ArticleType: echain_product_models_1.ArticleType.leitung,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
            Aderzahl: '0',
            AkeneoSku: '',
            ArticleSpecs: [],
            Bezeichnung: {},
            Categories: [],
            Leitungsaufbau: {},
            MainCategory: echain_shared_articles_1.LeitungCategory.BusCables,
            RAL_Nummer: '',
            ArtNr: {},
            ArtNrDE: '',
            ArtNrUS: '',
            AuhiGleitend: false,
            AuhiTemperaturMax: {
                Unit: 'K',
                Value: 1,
            },
            AuhiTemperaturMin: {
                Unit: 'K',
                Value: 0,
            },
            DataSource: 'mix',
            DiscontinuedModel: false,
            DESINA: false,
            DNV_GL: false,
            EAC: false,
            EchainId: Article_1.echainIdDummy,
            Flammwidrig: false,
            FreigabeECF: false,
            FreigabeEIC: false,
            FreigabeEIQ: false,
            FreigabeEKE: false,
            FreitragenderBetriebErlaubt: false,
            Gesamtschirm: false,
            HaengenderBetriebErlaubt: false,
            Halogenfrei: false,
            Kuehlmittelbestaendig: false,
            Mantelwerkstoff: echain_product_models_1.Mantelwerkstoff.PUR,
            MUDBestaendig: false,
            Oelbestaendigkeit: echain_product_models_1.OelBestaendigkeit.Class1,
            Querschnitt: {},
            Reinraum: false,
            Schirmung: false,
            Torsionsfaehig: false,
            TwistedPair: false,
            UL_CSA: false,
            Ungeschirmt: false,
            UVBestaendigkeit: echain_product_models_1.UvBestaendigkeit.Gering,
            HatStecker: false,
            FesteLaenge: false,
        });
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Leitung.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const leitung = Leitung.fromJson(args, cloneStrategy);
        leitung.artNrExists = true;
        leitung.isPlaceholder = false;
        return leitung;
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Leitung.fromInventedArtNr: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const leitung = Leitung.fromJson(args, cloneStrategy);
        leitung.artNrExists = false;
        leitung.artNr = undefined;
        leitung.isPlaceholder = false;
        return leitung;
    }
    static fromPlaceholderArgs(args, cloneStrategy = 'deep') {
        const leitung = Leitung.fromJson(args, cloneStrategy);
        leitung.artNrExists = false;
        leitung.isPlaceholder = true;
        return leitung;
    }
    static fromJson(args, cloneStrategy = 'deep') {
        const leitung = Leitung.fromScratch();
        leitung.fromJson(args, cloneStrategy);
        return leitung;
    }
    static fromModel(model) {
        const leitung = Leitung.fromScratch();
        Object.assign(leitung.model, model);
        Object.assign(model, leitung.model);
        leitung.model = model;
        return leitung;
    }
    /** Retrieves whether the property `leitungslaenge` is currently locked in any way */
    get leitungslaengeLocked() {
        return (this.laengeUeberstandLock === echain_shared_articles_1.LeitungslaengeUeberstandLock.laengeOnly ||
            this.laengeUeberstandLock === echain_shared_articles_1.LeitungslaengeUeberstandLock.laengeAndMitnehmer ||
            this.laengeUeberstandLock === echain_shared_articles_1.LeitungslaengeUeberstandLock.laengeAndFestpunkt);
    }
    setIAIndexAsNumber(v) {
        if (v == null)
            this._iaIndex = undefined;
        else
            this._iaIndex = (this.isPlaceholder ? 'F' : '') + v;
    }
    getIAIndexAsNumber() {
        if (this._iaIndex == null)
            return undefined;
        else
            return parseInt(this._iaIndex.replace(/^F/, ''), 10);
    }
    /**
     * Clears the ia index if it is set.
     */
    clearIAIndex() {
        if (this._iaIndex != null) {
            this.setIAIndexAsNumber(undefined);
        }
    }
    /**
     * Clears the local transform.
     */
    clearLocalTransform() {
        this.localTransform = undefined;
    }
    /**
     * Clears all data related to Innenaufteilung.
     */
    clearAllIAData() {
        this.clearIAIndex();
        this.clearLocalTransform();
    }
    clone() {
        return this._clone(Leitung.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
    /**
     * Set the leitung RAL color for the given LeitungCategory.
     */
    setRalColorByLeitungCategory(leitungCategory) {
        this.ralNummer = '6005';
        switch (leitungCategory) {
            case echain_shared_articles_1.LeitungCategory.ControlCables:
                this.ralNummer = '6005';
                break;
            case echain_shared_articles_1.LeitungCategory.DataCables:
                this.ralNummer = '7001';
                break;
            case echain_shared_articles_1.LeitungCategory.BusCables:
                this.ralNummer = '4001';
                break;
            case echain_shared_articles_1.LeitungCategory.MeasuringSystemCables:
                this.ralNummer = '6018';
                break;
            case echain_shared_articles_1.LeitungCategory.ServoCables:
                this.ralNummer = '2003';
                break;
            case echain_shared_articles_1.LeitungCategory.MotorCables:
                this.ralNummer = '5013';
                break;
            case echain_shared_articles_1.LeitungCategory.PneumaticHoses:
                this.ralNummer = '6005';
                break;
            case echain_shared_articles_1.LeitungCategory.HydraulicCables:
                this.ralNummer = '6005';
                break;
            default:
                this.ralNummer = '6005';
                break;
        }
    }
    /**
     * should return the localized bezeichnungstext if leitung is placeholder.
     * Otherwise, the function should return the article number.
     */
    getArtNrOrLocalizedBezeichnungForPlaceholder(localizedTextResolver) {
        if (this.isPlaceholder) {
            if (this.bezeichnung) {
                return localizedTextResolver.resolve(this.bezeichnung);
            }
            else {
                return undefined;
            }
        }
        else {
            return this.artNrGenerated || this.artNr;
        }
    }
    /**
     * should return undefined if leitung is placeholder.
     * Otherwise, the function should return the beschriftungstext.
     */
    getBeschriftungIfNoPlacholder() {
        if (this.isPlaceholder) {
            return undefined;
        }
        else {
            if (this.beschriftungText) {
                return this.beschriftungText;
            }
            else {
                return undefined;
            }
        }
    }
    /**
     * should return undefined if leitung ist placeholder.
     * Otherwise, the function should return the localized bezeichnung.
     */
    getBezeichnungIfNoPlacholder(localizedTextResolver) {
        if (this.isPlaceholder) {
            return undefined;
        }
        else {
            if (this.bezeichnung) {
                return localizedTextResolver.resolve(this.bezeichnung);
            }
            else {
                return undefined;
            }
        }
    }
    getReadycableBaseArticleRefArtNr(localizedTextResolver) {
        var _a;
        const artNrLocalizedText = (_a = this.baseArticleRef) === null || _a === void 0 ? void 0 : _a.ArtNr;
        if (!this.isReadycable() || !artNrLocalizedText) {
            return undefined;
        }
        return localizedTextResolver.resolve(artNrLocalizedText);
    }
    get leitungsaufbau() {
        return this.localizedLeitungsaufbau
            ? echain_shared_i18n_1.LocaleService.getUserArticleLocalizedText(this.localizedLeitungsaufbau)
            : undefined;
    }
    get busSystem() {
        return this.localizedBusSystem ? echain_shared_i18n_1.LocaleService.getUserArticleLocalizedText(this.localizedBusSystem) : undefined;
    }
    get querschnitt() {
        return this.localizedQuerschnitt ? echain_shared_i18n_1.LocaleService.getUserArticleLocalizedText(this.localizedQuerschnitt) : undefined;
    }
    hasSpec(spec) {
        var _a;
        return !!((_a = this.articleSpecs) === null || _a === void 0 ? void 0 : _a.includes(spec));
    }
    /** Retrieves true if the Leitung can be identified as readycable. If it cannot be determined it retrieves undefined. */
    isReadycable() {
        return this.hasSpec(echain_shared_articles_1.ArticleSpecs.Readycable);
    }
    /** Retrieves true if the Leitung can be identified as chainflex. If it cannot be determined it retrieves undefined. */
    isChainflex() {
        return this.hasSpec(echain_shared_articles_1.ArticleSpecs.Chainflex);
    }
    /**
     * Retrieves true if the Leitung can be identified as PullWire.
     */
    isPullWire() {
        return this.hasSpec(echain_shared_articles_1.ArticleSpecs.PullWire);
    }
    /** Retrieves true when IAItem is placed in a Kette (e.g. via IA-Editor) */
    isPlacedInKette() {
        var _a;
        return ((_a = this.localTransform) === null || _a === void 0 ? void 0 : _a.length) === 6;
    }
    get comment() {
        return this.model.Comment;
    }
    set comment(comment) {
        this.model.Comment = comment;
    }
}
exports.Leitung = Leitung;
//# sourceMappingURL=Leitung.js.map